/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 64:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _jsx = __webpack_require__(29);
var _extends = __webpack_require__(213);
/* eslint-disable react/forbid-prop-types */
/**
 * Module dependencies
 */
var React = __webpack_require__(689);
var _require = __webpack_require__(308),
  Switch = _require.Switch,
  Route = _require.Route;
var EMPTY_ARRAY = [];
var EMPTY_OBJECT = {};

/**
 * Routes Compoent - render switch with pages
 */
var Routes = function Routes(_ref) {
  var location = _ref.location,
    _ref$routes = _ref.routes,
    routes = _ref$routes === void 0 ? EMPTY_ARRAY : _ref$routes,
    _ref$extraProps = _ref.extraProps,
    extraProps = _ref$extraProps === void 0 ? EMPTY_OBJECT : _ref$extraProps;
  return routes && routes.length > 0 && /*#__PURE__*/_jsx(Switch, {
    location: location
  }, void 0, routes.map(function (route, i) {
    return /*#__PURE__*/_jsx(Route, {
      path: route.path,
      exact: route.exact,
      render: function render(props) {
        return /*#__PURE__*/React.createElement(route.component, _extends({}, props, extraProps, {
          route: route
        }));
      }
    }, route.key || i);
  }));
};
module.exports = Routes;

/***/ }),

/***/ 78:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _jsx = __webpack_require__(29);
var _defineProperty = __webpack_require__(779);
var _classCallCheck = __webpack_require__(537);
var _createClass = __webpack_require__(765);
var _assertThisInitialized = __webpack_require__(431);
var _inherits = __webpack_require__(370);
var _possibleConstructorReturn = __webpack_require__(548);
var _getPrototypeOf = __webpack_require__(761);
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/* eslint-disable react/forbid-prop-types */
/**
 * Module dependencies
 */
var React = __webpack_require__(689);
var matchRoute = __webpack_require__(669);
var Routes = __webpack_require__(64);
var EMPTY_ARRAY = [];

/**
 * This is going to be the container for all the Single Page Application Routes
 */
var AppContainer = /*#__PURE__*/function (_React$Component) {
  "use strict";

  _inherits(AppContainer, _React$Component);
  var _super = _createSuper(AppContainer);
  function AppContainer(props) {
    var _this;
    _classCallCheck(this, AppContainer);
    _this = _super.call(this, props);
    _this.state = {
      location: props.location,
      isFetching: false,
      firstRender: true,
      data: null
    };
    _this.fetch = _this.fetch.bind(_assertThisInitialized(_this));
    _this.updateState = _this.updateState.bind(_assertThisInitialized(_this));
    return _this;
  }

  /**
   * If the location change (page change), fetch the data and chunk
   * @param nextProps
   */
  /* eslint-disable camelcase */
  _createClass(AppContainer, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var location = this.props.location;
      if (location.pathname !== nextProps.location.pathname) {
        this.fetch(nextProps.location);
      }
    }

    /**
     * Update state when this change
     * @param {Object} location
     * @param {Boolean} isFetching
     * @param {Object} data
     * @param {Boolean} firstRender
     */
  }, {
    key: "updateState",
    value: function updateState(location) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var isFetching = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var firstRender = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var state = {
        location: location,
        isFetching: isFetching,
        data: data,
        firstRender: firstRender
      };
      if (!Object.is(this.state, state)) {
        this.setState(state);
      }
    }

    /**
     * Fetch next component and data before change Switch location
     * @param nextLocation
     */
  }, {
    key: "fetch",
    value: function fetch(nextLocation) {
      var _this2 = this;
      var _this$props = this.props,
        routes = _this$props.routes,
        history = _this$props.history;
      var _this$state = this.state,
        location = _this$state.location,
        data = _this$state.data;
      var route = matchRoute(routes, nextLocation.pathname);
      var promises = [];
      if (route) {
        // preload chunk
        promises.push(route.component.preload());

        // Fetch data from server
        if (route.fetchData) {
          promises.push(route.fetchData(route.params, nextLocation.state, history));
        }

        // Init transition to next page
        this.updateState(location, data, true);
        Promise.all(promises).then(function (responses) {
          var resData = responses[1] || {};

          // If handleRender is define SPAContainer delegate render
          if (route.handleRender) {
            route.handleRender(resData, history, nextLocation, route.params, _this2.updateState);
          } else {
            // Update Container state
            _this2.updateState(nextLocation, resData);
          }
        })["catch"](function () {
          _this2.updateState(location, data);
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state2 = this.state,
        firstRender = _this$state2.firstRender,
        location = _this$state2.location,
        isFetching = _this$state2.isFetching,
        data = _this$state2.data;
      var merged = _objectSpread(_objectSpread(_objectSpread({}, this.props), data), {}, {
        loading: isFetching,
        firstRender: firstRender
      });
      var _this$props$routes = this.props.routes,
        routes = _this$props$routes === void 0 ? EMPTY_ARRAY : _this$props$routes;
      return /*#__PURE__*/_jsx(Routes, {
        routes: routes,
        extraProps: merged,
        location: location
      });
    }
  }]);
  return AppContainer;
}(React.Component);
module.exports = AppContainer;

/***/ }),

/***/ 669:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _defineProperty = __webpack_require__(779);
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Module dependencies
 */
var _require = __webpack_require__(308),
  matchPath = _require.matchPath;

/**
 * Match pathname with routes
 * @param {Array} routes
 * @param {String} pathname
 */
module.exports = function () {
  var routes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var pathname = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var route = null;
  for (var i = 0; i < routes.length; i += 1) {
    if (routes[i].path) {
      var match = matchPath(pathname, routes[i]);
      if (match) {
        var matchParamKeys = Object.keys(match.params);

        // Remove ? from url params
        for (var j = 0; j < matchParamKeys.length; j += 1) {
          if (/\?$/.test(match.params[matchParamKeys[j]])) {
            match.params[matchParamKeys[j]] = match.params[matchParamKeys[j]].replace(/\?$/, '');
            break;
          }
        }
        route = _objectSpread(_objectSpread({}, routes[i]), {}, {
          component: routes[i].component,
          fetchData: routes[i].fetchData || null,
          params: match.params
        });
        break;
      }
    }
  }
  return route;
};

/***/ }),

/***/ 299:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _jsx = __webpack_require__(29);
/**
 * Module dependencies
 */
var React = __webpack_require__(689);
var _require = __webpack_require__(661),
  BrowserRouter = _require.BrowserRouter,
  withRouter = _require.withRouter;
var AppContainer = __webpack_require__(78);

/**
 * SPA Container
 */
var SPAContainer = function SPAContainer(props) {
  var _props$Container = props.Container,
    Container = _props$Container === void 0 ? null : _props$Container,
    _props$basePath = props.basePath,
    basePath = _props$basePath === void 0 ? '' : _props$basePath;
  var ContainerWithRouter = withRouter(Container || AppContainer);
  return /*#__PURE__*/_jsx(BrowserRouter, {
    basename: basePath
  }, void 0, /*#__PURE__*/React.createElement(ContainerWithRouter, props));
};
/**
 * Expose SPA Container
 */
module.exports = SPAContainer;

/***/ }),

/***/ 431:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/assertThisInitialized");

/***/ }),

/***/ 537:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/classCallCheck");

/***/ }),

/***/ 765:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/createClass");

/***/ }),

/***/ 779:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 213:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 761:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/getPrototypeOf");

/***/ }),

/***/ 370:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/inherits");

/***/ }),

/***/ 29:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/jsx");

/***/ }),

/***/ 548:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/possibleConstructorReturn");

/***/ }),

/***/ 689:
/***/ ((module) => {

"use strict";
module.exports = require("react");

/***/ }),

/***/ 308:
/***/ ((module) => {

"use strict";
module.exports = require("react-router");

/***/ }),

/***/ 661:
/***/ ((module) => {

"use strict";
module.exports = require("react-router-dom");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module is referenced by other modules so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__(299);
/******/ 	module.exports = __webpack_exports__;
/******/ 	
/******/ })()
;
//# sourceMappingURL=SPAContainer.js.map